import { Button } from '@vrplatform/components';
import { useBilling } from '@vrplatform/data';
import { useCallback, useState } from 'react';
import { AddCsvBankModal } from './AddCsvBankModal';
import {
  type ConfirmBankConnectionsData,
  ConfirmBankConnectionsModal,
} from './ConfirmBankConnectionsModal';
import { SelectBankModal } from './SelectBankModal';
import { useLocation } from 'react-router';

export const AddBankAccountButton = () => {
  const { state } = useLocation();

  const locationState = state as
    | { data: ConfirmBankConnectionsData }
    | undefined;

  const [setupData, setSetupData] = useState<ConfirmBankConnectionsData | null>(
    locationState?.data ?? null
  );
  const [opened, setOpened] = useState<'bank-select' | 'csv' | null>(null);

  const { isReadOnly } = useBilling();

  const closePlaidConfirmModal = useCallback(() => setSetupData(null), []);

  const openCsvModal = useCallback(() => {
    setOpened('csv');
  }, []);

  const closeModal = useCallback(() => {
    setOpened(null);
  }, []);

  if (isReadOnly) return null;

  return (
    <>
      <Button
        data-testid="add-bank-account"
        leftIcon={'PlusIcon'}
        onClick={() => setOpened('bank-select')}
        variant="primary"
      >
        Add account
      </Button>

      <SelectBankModal
        closeModal={closeModal}
        opened={opened === 'bank-select'}
        openCsvModal={openCsvModal}
        openSetupModal={setSetupData}
      />

      <AddCsvBankModal closeModal={closeModal} opened={opened === 'csv'} />

      <ConfirmBankConnectionsModal
        closeModal={closePlaidConfirmModal}
        data={setupData}
      />
    </>
  );
};
